import store from '../reducers';
import SpriteAction from '../reducers/sprite/action';

class Sprite {
    constructor() {

    }

    /**
     * 注入角色资源列表到素材库中
     * @param {Array} jsonData 数据列表
     */
    addSprites(jsonData) {
        store.dispatch(SpriteAction.update('libs', jsonData));
    }

    addCostumes(jsonData) {
        store.dispatch(SpriteAction.update('costumes', jsonData));
    }

    addSounds(jsonData) {
        store.dispatch(SpriteAction.update('sounds', jsonData));
    }

    addBackdrops(jsonData) {
        store.dispatch(SpriteAction.update('backdrops', jsonData));
    }
}

export default Sprite;